import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { I18nPluralPipe } from '@angular/common';

import { has, cloneDeep, forEach } from 'lodash';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

import { NOTIFICATIONS_PATHS } from '../../../../pages/notifications/notifications';
import { NotificationsService } from '../../../../services/notifications.service';
import { PagesMapService } from '../../../../pages/pages.map';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-topbar-notifications-popover',
  templateUrl: './topbar-notifications-popover.component.html',
  styleUrls: ['./topbar-notifications-popover.component.scss'],
  standalone: false,
})
export class TopbarNotificationsPopoverComponent implements OnInit, OnChanges {
  moment = require('moment');
  NOTIFICATIONS_PATHS = NOTIFICATIONS_PATHS;
  bellColor: string;
  notificationsCounts: number;
  notificationsLimit: number;
  isExistsHiddenNotifications: boolean;
  notificationsHiddenCounts: number;
  notificationsDefault: any;
  notificationsList;
  notificationChangeStatusLoading: boolean;
  notificationChangeStatusLoadingId: number | null;
  currentDate: string;
  itemPluralMapping = {
    notification: {
      '=1': 'уведомление',
      '=2': 'уведомления',
      '=3': 'уведомления',
      '=4': 'уведомления',
      other: 'уведомлений',
    },
  };

  @Input() priority;
  @Input() notifications;
  @Input() count;
  @ViewChild('p2') popover: NgbPopover;

  constructor(
    private notificationsService: NotificationsService,
    private pagesMapService: PagesMapService
  ) {
    this.notificationsCounts = 0;
    this.notificationsLimit = 5;
    this.isExistsHiddenNotifications = false;
    this.notificationsHiddenCounts = 0;
    this.currentDate = this.moment(new Date()).format('YYYY-MM-DD');
  }

  ngOnInit() {
    this.notificationsDefault = cloneDeep(this.notifications);

    this.makePartialData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (has(changes, 'notifications.currentValue') && changes.notifications.currentValue) {
      this.notificationsDefault = cloneDeep(changes.notifications.currentValue);

      this.makePartialData();
    }
  }

  makePartialData() {
    let fullCounts = 0;
    let order = 0;
    let countMakeNotification = 0;
    let notifications: any = {};

    this.notificationsList = [];

    forEach(cloneDeep(this.notificationsDefault), (interval) => {
      if (has(interval, 'notifications') && interval.notifications.length) {
        order++;
        forEach(interval.notifications, (notification) => {
          fullCounts++;
          if (countMakeNotification < this.notificationsLimit) {
            if (!has(notifications, interval.date)) {
              notifications[interval.date] = {
                notifications: [],
                order: order,
              };
              notifications[interval.date].notifications.push(notification);
              countMakeNotification++;
            } else {
              notifications[interval.date].notifications.push(notification);
              countMakeNotification++;
            }
          }
        });
      }
    });

    forEach(notifications, (val, key) => {
      this.notificationsList.push({
        date: key,
        notifications: val['notifications'],
      });
    });

    this.notificationsCounts = fullCounts;
    this.isExistsHiddenNotifications = this.count > this.notificationsLimit;
    this.notificationsHiddenCounts = this.count - this.notificationsLimit;
    this.bellColor =
      this.priority === 'high'
        ? this.notificationsCounts
          ? 'color-red-dark'
          : 'color-gray-dark opacity-6'
        : this.notificationsCounts
          ? 'color-blue-dark'
          : 'color-gray-dark  opacity-6';
  }

  onChangeNotificationStatus(notification) {
    let notifList = this.notificationsList;
    let nofifListNotifications = notifList[notifList.length - 1].notifications;
    let lastShowNotificationId = nofifListNotifications[nofifListNotifications.length - 1].id;
    this.notificationChangeStatusLoading = true;
    this.notificationChangeStatusLoadingId = notification.id;
    this.notificationsService
      .changeNotificationStatus({
        status: 1,
        notification_id: notification.id,
        last_visible_notification_id: lastShowNotificationId,
      })
      .subscribe(
        (response) => {
          // this.removeNotification(notification.id);
          this.notificationChangeStatusLoading = false;
          this.notificationChangeStatusLoadingId = null;
        },
        (error) => {
          console.log(error);
          this.notificationChangeStatusLoading = false;
          this.notificationChangeStatusLoadingId = null;
        }
      );
  }

  removeNotification(id) {
    let intervalIndex, notificationIndex;

    forEach(this.notificationsDefault, (inverval, intIndex) => {
      forEach(inverval.notifications, (notification, notIndex) => {
        if (id === notification.id) {
          intervalIndex = intIndex;
          notificationIndex = notIndex;
        }
      });
    });

    if (intervalIndex > -1 && notificationIndex > -1) {
      this.notificationsDefault[intervalIndex].notifications.splice(notificationIndex, 1);
    }

    this.makePartialData();
  }

  toggleWithNotificationsContext(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  onNavigate() {
    this.popover.close();
  }
}
